"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = KeyboardAvoidingScrollView;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _reactNative = require("react-native");
function KeyboardAvoidingScrollView(props) {
  var reference = props.reference;
  return /*#__PURE__*/_react["default"].createElement(_reactNative.ScrollView, (0, _extends2["default"])({
    ref: reference
  }, props));
}